import appSettings from 'wanderu-config';
import Logger from 'wanderu-logger';
import AccountService from 'wanderu-service-account';
import { SnowplowService } from 'wanderu-service-analytics';

import { actions as userInfoActions } from '../../appstate/userInfo';
import { formatOrder } from '../utils';
import { actions } from './base';

const logger = Logger.getLogger('wanderu-ducks-account');

function reset(processingId) {
    return actions.reset(processingId);
}

function check(processingId) {
    return async (dispatch) => {
        dispatch(actions.startWork(processingId));

        let error;
        let meta = {};
        try {
            const updatedOrder = await AccountService.checkCancellation(processingId);
            const formattedOrder = formatOrder(updatedOrder);
            return dispatch(userInfoActions.updateUserOrder(formattedOrder));
        } catch (ex) {
            const domainUserInfo = appSettings.env.isClient
                ? SnowplowService.getDomainUserInfo()
                : {};

            logger.error('checkCancellation', ex, {
                snowplowIds: {
                    networkUserId: SnowplowService.getNetworkUserId(),
                    ...domainUserInfo,
                },
            });

            error = {
                code: ex.code,
                message: ex.message,
                name: ex.name,
            };
        } finally {
            dispatch(actions.endWork(processingId, meta, error));
        }
    };
}

export {
    check,
    reset,
};
